import React, { memo, useCallback, useEffect, useState } from "react";
import SearchFilter from "./SearchFilter";
import DCard from "./DCard";
import { Menu, MenuButton } from "@chakra-ui/react";
import { icon } from "../utils/icons";

const ListInput = ({
  title,
  enableFilter = true,
  options = [],
  selectValue,
  setSelectValue,
  disabled = false,
}) => {
  const [filter, setFilter] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  useEffect(() => {
    setSelectedOption(options?.find((option) => option.value === selectValue));
    if (options.length > 0) {
      setSelectValue(options[0].value);
    }
  }, [selectValue]);
  const filterOptions = useCallback(
    (value) => {
      setFilter(value);
    },
    [filter]
  );
  // select value handler
  const selectValueHandler = (value, close) => {
    setSelectValue(value);
    setSelectedOption(options.find((option) => option.value === value));
    close();
  };

  return (
    <div className="relative">
      {title && <p className="text-sm md:text-[1rem] mb-2">{title}</p>}
      <Menu closeOnBlur={false}>
        {({ isOpen, onClose }) => {
          return (
            <div className="relative">
              <MenuButton
                type="button"
                className="p-2  relative  overflow-hidden w-full min-h-[42px]   border rounded-lg transition-all  focus:border-third-color shadow-sm outline-none border-light-color"
              >
                <p className="flex text-[1rem] justify-between items-center">
                  {selectedOption?.key ||
                    selectedOption?.value ||
                    options[0]?.key ||
                    options[0]?.value}{" "}
                  {icon.chevronDown}
                </p>
              </MenuButton>
              <DCard
                onBlur={onClose}
                className={`absolute z-[40]  top-[calc(100%_+_5px)]   w-full rounded-lg shadow-sm p-2 border border-primary-border dark:border-primary-border-dark  transition-all bg-white dark:bg-secondry-dark ${
                  isOpen && !disabled
                    ? "visible opacity-1"
                    : "invisible opacity-0"
                }`}
              >
                {enableFilter && (
                  <SearchFilter
                    changeHandler={filterOptions}
                    value={filter}
                    className="border-0 border-b shadow-none rounded-none"
                  />
                )}
                <ul className="max-h-[300px] overflow-y-auto scrollbar-hide">
                  {options
                    ?.filter(
                      (option) =>
                        (option?.key
                          ?.toLowerCase()
                          .includes(filter?.toLowerCase()) ||
                          option.value
                            ?.toLowerCase()
                            .includes(filter?.toLowerCase())) &&
                        option?.value !== ""
                    )
                    .map((option) => (
                      <p
                        key={option.value}
                        as="li"
                        className="p-2 hover:bg-light-color cursor-pointer"
                        onClick={() =>
                          selectValueHandler(option.value, onClose)
                        }
                      >
                        {option?.key || option.value}
                      </p>
                    ))}
                </ul>
              </DCard>
            </div>
          );
        }}
      </Menu>
    </div>
  );
};

export default memo(ListInput);
